export const menuItems = [
  {
    id: 1,
    label: "Users",
    link: "/users",
    acl: ["admin"],
    icon: "IcUsers",
  },
];
